export const formatDate = (date) => {
  if (!date.match(/\d{4}-\d{2}-\d{2}/g)) {
    const formattedDate = date.replace(/\//g, '')
    const day = formattedDate.slice(0, 2)
    const month = formattedDate.slice(2, 4)
    const year = formattedDate.slice(4, 8)

    return `${year}-${month}-${day}`
  } else {
    return date
  }
}

export const formatValue = (value) => value.replace(/\./g, '').replace(',', '.')
export const formatIntToDecimal = (value) =>
  value ? value.toString().replace(/\./g, '') + '.00' : ''

export const formatTickerName = (ticker) => {
  let tickerName = ''

  const newTicker = {
    sequenceNumber: ticker.sequenceNumber,
    debtor: ticker.debtor.value ? ticker.debtor.value : ticker.debtor,
    state: ticker.state.value ? ticker.state.value : ticker.state,
    classification: ticker.classification.value
      ? ticker.classification.value
      : ticker.classification
  }

  switch (newTicker.classification) {
    case 'precatorio':
      tickerName += 'P'
      break
    case 'legalAsset':
      tickerName += 'D'
      break
    default:
      tickerName += 'O'
  }

  switch (newTicker.debtor) {
    case 'federal':
      tickerName += 'FED'
      break
    case 'state':
      tickerName += 'E'
      break
    case 'city':
      tickerName += 'M'
      break
    default:
      tickerName += ''
  }

  if (newTicker.debtor != 'federal') tickerName += newTicker.state

  if (newTicker.sequenceNumber <= 9) {
    tickerName += `0${newTicker.sequenceNumber}`
  } else {
    tickerName += `${newTicker.sequenceNumber}`
  }

  return tickerName
}

export const monthDiff = (dateFrom, dateTo) => {
  dateFrom = new Date(dateFrom)
  dateTo = new Date(dateTo)
  return (
    dateTo.getMonth() -
    dateFrom.getMonth() +
    12 * (dateTo.getFullYear() - dateFrom.getFullYear())
  )
}

export const validateCpf = (cpf) => {
  cpf = cpf.replace(/\.|-/g, '')
  if (
    !cpf ||
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  )
    return false

  let sum = 0
  let remainder
  for (let i = 1; i <= 9; i++)
    sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i)
  remainder = (sum * 10) % 11
  if (remainder == 10) remainder = 0
  if (remainder != parseInt(cpf.substring(9, 10))) return false
  sum = 0
  for (let i = 1; i <= 10; i++)
    sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i)
  remainder = (sum * 10) % 11
  if (remainder == 10) remainder = 0
  if (remainder != parseInt(cpf.substring(10, 11))) return false
  return true
}

export const getMask = (value) => {
  if (value) {
    const valueLength = value
      .toString()
      .split('.')
      .join('').length
    let mask
    if (valueLength == 4) {
      mask = '#.###'
    } else if (valueLength == 5) {
      mask = '##.###'
    } else if (valueLength == 6) {
      mask = '###.###'
    } else if (valueLength == 7) {
      mask = '#.###.###'
    } else if (valueLength == 8) {
      mask = '##.###.###'
    } else if (valueLength == 9) {
      mask = '###.###.###'
    } else if (valueLength == 10) {
      mask = '#.###.###.###'
    } else if (valueLength == 11) {
      mask = '##.###.###.###'
    } else {
      mask = '#################'
    }
    return mask
  }
}
